import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { Subscription } from "rxjs";
import { LanguageService } from './../../../Services/languageService';
import { RouterModule, Routes, Router } from '@angular/router';
import { mdlProposalAddRes_Upgrade } from '../../../Models/mdlProposalAddRes_Upgrade';
import { renewPolicyModel } from '../../../Models/policyModel';
import { mdlCheckEligibilityRes } from '../../../Models/mdlCheckEligibilityRes';
import { mdlPayFortRequestDetailsRes } from '../../../Models/mdlPayFortRequestDetailsRes';
import { ProposalModel } from '../../../Models/ProposalModel';
import { restURL } from '../../../Models/restURL';
import { motorProposalService } from '../../../Services/motorProposalService';

@Component({
  selector: 'PayfortConfirmUpgrade',
  templateUrl: './PayfortConfirmUpgrade.html',
  styleUrls: ['./PayfortConfirmUpgrade.css']
})
export class PayfortConfirmUpgrade {

  public isShowLoading: boolean = false;
  public agreeTerms: boolean = false;
  public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public LngSubscription: Subscription;
  public Lng: string;
  public PMethod:string;
  public ProposalNo:string;
  public Insured_Name: string;
  public totalPremium: number;
  public objProposalAddRes_Upgrade: mdlProposalAddRes_Upgrade = new mdlProposalAddRes_Upgrade();
  public proposalObj: ProposalModel = new ProposalModel();
  public objCheckEligibilityRes: mdlCheckEligibilityRes = new mdlCheckEligibilityRes();
  public objmdlPayFortRequestDetailsRes: mdlPayFortRequestDetailsRes = new mdlPayFortRequestDetailsRes();
    
  constructor(private EncriptService: motorProposalService,private lngService: LanguageService,private url: restURL){
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => {
      this.Lng = lng
    });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.objProposalAddRes_Upgrade = JSON.parse(sessionStorage.getItem("objProposalAddRes_Upgrade"));
    this.objCheckEligibilityRes = JSON.parse(sessionStorage.getItem("objCheckEligibilityRes"));
    //this.proposalObj = JSON.parse(sessionStorage.getItem("paymentObj"));
    if(sessionStorage.getItem("paymentObj") != null){
      this.proposalObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("paymentObj")));
    }
    
    this.objmdlPayFortRequestDetailsRes = JSON.parse(sessionStorage.getItem("objmdlPayFortRequestDetailsRes"));
    this.PMethod = sessionStorage.getItem("PaymentType");
    this.ProposalNo = this.objProposalAddRes_Upgrade.ProposalNo ? this.objProposalAddRes_Upgrade.ProposalNo : this.proposalObj.ProposalNo;
    this.totalPremium = this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE ? this.objCheckEligibilityRes.TOTAL_AMOUNT_UPGRADE : this.proposalObj.TotalPremium;
    this.Insured_Name = this.Lng =="en"? sessionStorage.getItem("InsuredName"):sessionStorage.getItem("NameAr");
    
  }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PayfortUpgrade/PayfortConfirmUpgrade/PayfortConfirmUpgrade.ts